var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfluencers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "blog_post",
    "data-name": "blog post",
    width: 40,
    height: 40,
    transform: "translate(1110 1474)",
    fill: "rgba(0,0,0,0.13)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_95828",
    "data-name": "Mask Group 95828",
    transform: "translate(-1110 -1474)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172073",
    "data-name": "Group 172073",
    transform: "translate(1119 1481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172072",
    "data-name": "Group 172072",
    transform: "translate(1.825 6.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172070",
    "data-name": "Group 172070",
    transform: "translate(4.543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172096",
    "data-name": "Path 172096",
    d: "M12.477,15.034a4.3,4.3,0,1,1,4.3-4.3A4.3,4.3,0,0,1,12.477,15.034Z",
    transform: "translate(-8.18 -6.44)",
    fill: "#E39DFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_172071",
    "data-name": "Group 172071",
    transform: "translate(0 9.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172097",
    "data-name": "Path 172097",
    d: "M13.51,23.559a10.933,10.933,0,0,1-8.53-4.077l-.311-.375.22-.44a9.549,9.549,0,0,1,6.42-5.151l.3-.065.272.155a3.294,3.294,0,0,0,3.262,0l.272-.155.3.065a9.56,9.56,0,0,1,6.42,5.138l.22.44-.311.375A10.905,10.905,0,0,1,13.51,23.559Z",
    transform: "translate(-4.67 -13.45)",
    fill: "#E39DFF"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_172098",
    "data-name": "Path 172098",
    d: "M6.934,14.843a7.028,7.028,0,1,1,12.348,0",
    transform: "translate(-2.43 -0.955)",
    fill: "none",
    stroke: "#E39DFF",
    strokeLinecap: "round",
    strokeWidth: 1.196
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172099",
    "data-name": "Path 172099",
    d: "M4.464,17.334a10.665,10.665,0,1,1,20.127-4.918,10.511,10.511,0,0,1-1.2,4.918",
    transform: "translate(-3.26 -1.75)",
    fill: "none",
    stroke: "#E39DFF",
    strokeLinecap: "round",
    strokeWidth: 1.196
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfluencers);
export default __webpack_public_path__ + "static/media/influencers.cd7e5990506df603c9cdb614ad78a5b5.svg";
export { ForwardRef as ReactComponent };